import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!this.element.classList.contains("visible")) return;

    const url = new URL(window.location.href);
    if (!url.searchParams.has("created")) return;

    // Clean ?created=true from the URL bar immediately.
    url.searchParams.delete("created");
    window.history.replaceState({}, "", url.toString());

    // Auto-copy the clean journal URL to clipboard.
    const journalUrl = window.location.origin + url.pathname;
    navigator.clipboard.writeText(journalUrl).then(() => {
      const hint = this.element.querySelector<HTMLElement>(".toast-copied");
      if (hint) hint.style.display = "block";
    }).catch(() => {});

    setTimeout(() => this.element.classList.remove("visible"), 6000);
  }

  show(message: string) {
    this.element.textContent = message;
    this.element.classList.add("visible");
    setTimeout(() => this.element.classList.remove("visible"), 3000);
  }
}
